export default "__VITE_ASSET__Db$ezKt2__"